export var appConfig = {
	showPasswordChangeButtonOnLogin: true,
	//loginText: "If you experience any problems logging in, please notify us at <a href=\"mailto:support@insa-software.com\"> support@insa-software.com</a>.",
	loginText:
		'To obtain login credentials, please contact us at <a href="mailto:support@insa-software.com"> support@insa-software.com</a>.',
	performanceChartSecondSerieName: "Cumulative Performance",
	portfolioGridSmallScreenColumns: [
		"SecName",
		"Quantity",
		"Currency",
		"CurrentPrice",
		"Valuation",
		"ProfitPerc",
	],
	transactionsGridSmallScreenColumns: [
		"SecName",
		"QuantityWithoutCash",
		"TransAmountRC",
		"TransDate",
		"Description",
	],
	allowedGenericForms: ["All"],
	hidePerformanceChartListColumn: true,
	clientSpecificColumnHidden: ["InterestFrequency", "SecISIN"],
	hideSecurityPricesVolume: false,
	sortTransactionsByDefault: false,
	multiSelectWidthSettings: false,
	dropdownWidthSettings: false,
	hideIncludeIgnoredTransactions: false,
	setCarouselTimeout: 10000,
	showThemeSelection: false,
	menuShowRiskProfile: false,
	menuShowClientContacts: false,
	menuShowMainWindow: false,
	menuShowGenericForms: false,
	menuShowDashboard: false,
	menuShowSecurity: true,
	menuShowCrossRates: true,
	menuShowOrdersWindow: false,
	consolidateAllPositionsVisible: true,
  	separatePositionsByPortfolioVisible: true,
	InsaCronAvailable: false,
  	portalLoginStatsAvaliable: false,
	SecMainClass_LIQUIDITY: 0,
	chartColors: [
		"#00dcfa",
		"#00b4c8",
		"#008ca0",
		"#005f69",
		"#004147",
		"#6C7071",
		"#555859",
		"#3A3D3D",
		"#202121",
	],
	ClientTitle: "Insa Online",
	ActiveIsChecked: false,
	menuShowInsaTrader: false,
	useLegacyIcons: true,
	initialSettings: {
		enabled: false,
		redirectAfterLogin: "overview",
		dateFrom: "startOfYear",
		dateTo: "today",
		currency: "CHF",
		availableCurrencies: "all",
		partner: "all",
		portfolios: "all",
	},
	customIconGraph: {
		enabled: false,
		fallBackSecurity: "AMZN",
		pageRedirect: "/trader",
	},
	customReport: false,
	OverviewCards: [
		"Portfolio",
		"Charts",
		"Performance",
		"Transactions",
		"CrossRates",
		"News",
	],
};



// WEBPACK FOOTER //
// ./insa-css/insa-clients/LWP/insaweb.config.ts